import { useState } from "react";
import api from "../lib/api";
import { Check } from "lucide-react";

export default function Newsletter({ variant = "light", source = "home" }) {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("idle");
    const [error, setError] = useState("");
    const dark = variant === "dark";

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        if (!email.includes("@")) { setError("Email invalide."); return; }
        setStatus("loading");
        try {
            await api.post("/newsletter", { email, source });
            setStatus("success");
            setEmail("");
        } catch { setStatus("error"); setError("Oups, réessayez."); }
    };

    return (
        <form onSubmit={submit} data-testid={`newsletter-form-${source}`} className="w-full">
            <div className={`flex items-end border-b ${dark ? "border-cp-ivoire/40" : "border-cp-encre/30"}`}>
                <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="votre@adresse.email"
                    data-testid={`newsletter-input-${source}`}
                    className={`flex-1 bg-transparent outline-none py-3 font-serif text-2xl font-light italic ${
                        dark ? "text-cp-ivoire placeholder:text-cp-ivoire/40" : "text-cp-encre placeholder:text-cp-gris-clair"
                    }`}
                />
                <button
                    type="submit"
                    disabled={status === "loading"}
                    data-testid={`newsletter-submit-${source}`}
                    className={`cp-tiny pb-3 px-1 transition-colors ${dark ? "text-cp-sable hover:text-cp-ivoire" : "text-cp-encre hover:text-cp-foret"}`}
                >
                    {status === "loading" ? "…" : "M'inscrire →"}
                </button>
            </div>
            {status === "success" && (
                <p data-testid={`newsletter-success-${source}`} className={`cp-script text-xl mt-3 ${dark ? "text-cp-sable" : "text-cp-foret"}`}>
                    <Check size={14} strokeWidth={1.5} className="inline mr-1 -mt-1" /> Votre première lettre arrive bientôt.
                </p>
            )}
            {error && <p className="cp-tiny mt-2 text-red-400">{error}</p>}
        </form>
    );
}
